import React from "react";

import styles from './Loading.module.scss';

const Loading = ({ isLoading= false }) => {
  return (
      <div className={ `${styles.wrapper} ${ isLoading ? '' : styles.notLoading }` }>
        <div className={ styles.loader }>
            <div></div>
            <div></div>
        </div>
      </div>
  )
}

export default Loading;
